import { Box, Grid, TextField } from "@material-ui/core";
import React, { Fragment, useEffect, useState } from "react";
import Autocomplete from "../../controls/Autocomplete/Autocomplete";
import CustomButton from "../../controls/Button/CustomButton";
import { useResizeScreen } from "../../hooks/useResizeScreen";
import useStyles from "../../assets/styles/styles";
import AutocompleteCartillaLocalidades from "../../controls/Autocomplete/AutocompleteCartillaLocalidades";
import { cleanPerfilCompleto, getAllCartillasUrl, resetMedicalRecordError } from "../../redux/actions/medicalRecords";
import { useDispatch, useSelector } from "react-redux";
import { showErrorMessageModalRetry, alphabeticalOrderDescription } from "../../utils/utilsFunctions";

const MedicalForm = (props) => {
    const { handleSubmit, setOptionsCartilla, planes, errors,
        zonas, tipoPrestador,
        loading, userPlan, filtersCartilla,
        handleCleanSearch, modelCartilla,
        selectedValues,
        setModelCartilla,
        disableAlphabeticSearch,
        setSelectedValues, disableZone, values,
        disableCity, disableProvider, disable,
        setValues, setSearchAddress, setDisableZone,
        setDisableProvider, setDisableCity, setDisableAlphabeticSearch, setDisable,
    } = props;
    const { screen } = useResizeScreen();
    const classes = useStyles();
    const [resetLocaltiesSelection, setResetLocaltiesSelection] = useState(0);
    const [resetPlan, setResePlanSelection] = useState(0);
    const dispatch = useDispatch();
    const errorMessage = useSelector(state => state.cartillaReducer.msgError);
    const [openError, setOpenError] = useState();
    const cartillasUrl = useSelector(state => state.cartillaReducer.allCartillasUrl);

    const selectedPlanDescripcion =
        (selectedValues?.plan && selectedValues.plan.trim()) ||
        (userPlan && userPlan.itemDescripcion?.trim());

    const selectedPlan = planes.find(
        p => p.itemDescripcion && p.itemDescripcion.trim() === selectedPlanDescripcion
    );

    const planCodigoSeleccionado = selectedPlan?.itemCodigo?.toString();

    const cartillaPlan = cartillasUrl?.find(
        c => c.estaActivo && c.plan?.toString() === planCodigoSeleccionado
    );

    useEffect(() => {
        dispatch(getAllCartillasUrl());
    }, []);

    const handleDescargarCartilla = () => {
        if (!cartillaPlan) return;
        const link = document.createElement("a");
        link.href = cartillaPlan.link;
        link.target = "_blank";
        link.download = "";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    function Responsive() {
        let width = screen.sWidth;
        if (width <= 1000) return `${classes.divFiltersMobile} `;
    }

    function disableFunction(propDisabled) {
        return propDisabled ? classes.disableTextField : classes.enableTextField;
    }

    function setOptionsCity(filtersCartillaValues) {
        if (filtersCartillaValues.localidadesBarrios?.localidadBarrio !== undefined) {
            var localities;
            localities = filtersCartillaValues.localidadesBarrios?.localidadBarrio.sort(function (a, b) {
                if (a.itemDescripcion > b.itemDescripcion) {
                    return 1;
                }
                if (a.itemDescripcion < b.itemDescripcion) {
                    return -1;
                }
                return 0;
            });
            
            if (localities.length > 1) {
                const totalOptions = {
                    itemCodigo: "TODAS",
                    itemDescripcion: "TODAS"
                };
                localities = [totalOptions, ...localities];
            }
            
            return localities;
        } else {
            return [""];
        }
    }

    function setOptionsEspecialidadesEstudios(filtersCartillaEstudiosValues) {
        if (
            filtersCartillaEstudiosValues.especialidadesEstudios
                ?.especialidadesEstudios !== undefined
        ) {
            const list = filtersCartillaEstudiosValues.especialidadesEstudios?.especialidadesEstudios;

            return alphabeticalOrderDescription(list);
        } else {
            return [""];
        }
    }

    function verifyZone(zoneValue) {
        let actualZone = modelCartilla?.FiltroZona;
        if (!actualZone || actualZone === 0) {
            actualZone = selectedValues?.zone || zoneValue;
        }
        if (actualZone?.toString() === "101") {
            return "BARRIO";
        } else if (actualZone === null || actualZone === undefined || actualZone === 0) {
            return "LOCALIDAD/BARRIO";
        } else {
            return "LOCALIDAD";
        }
    }

    function verifyLabelEspecialidad(providerValue) {
        if (providerValue === "140") {
            return "ESTUDIOS COMPLEMENTARIOS";
        } else {
            return "ESPECIALIDAD";
        }
    }

    useEffect(() => {
        if (selectedValues?.zone && values?.zone) {
            setResetLocaltiesSelection(prev => prev + 1);
        }
        if (selectedValues?.plan && values?.plan) {
            setResePlanSelection(prev => prev + 1);
        }
    }, [values?.zone, values?.plan])

    useEffect(() => {
        if (values.alphabeticalSearch) {
            setValues(prev => ({ ...prev, alphabeticalSearch: "" }));
            setSelectedValues(prev => ({ ...prev, alphabeticalSearch: "" }));
            setModelCartilla(prev => ({ ...prev, FiltroRazonSocial: "" }));
        }
    }, [selectedValues.plan, selectedValues.zone, selectedValues.city, selectedValues.provider, selectedValues.department]);

    function isProviderValid(provider, tipoPrestador) {
        return tipoPrestador.some(tp => tp.itemDescripcion === provider);
    }

    useEffect(() => {
        if (values.alphabeticalSearch === "") {
            setModelCartilla(prev => ({
                ...prev,
                FiltroRazonSocial: "",
            }));
            setSelectedValues(prev => ({ ...prev, alphabeticalSearch: "" }));
        }
    }, [values.alphabeticalSearch]);


    useEffect(() => {
        if (errorMessage !== "" && errorMessage !== undefined) {
            setOpenError(true);
        }
    }, [errorMessage]);

    const isSearchDisabled = () => {
        const allOptionSelected = Array.isArray(selectedValues.city) && selectedValues.city.some(c => c.itemCodigo === "TODAS");
        const citySelected = Array.isArray(selectedValues.city) && selectedValues.city.length > 0;
        
        return (
            !selectedValues.plan ||
            !selectedValues.zone ||
            !selectedValues.provider ||
            (!allOptionSelected && !citySelected)
        );
    };

    return (
        <Fragment>
            <form
                style={{ flexWrap: "wrap" }}
                className={`${classes.divFilterBtn} ${Responsive()}`}
                onSubmit={handleSubmit}
            >
                <>
                    <Grid className={classes.gridFirstContainerCartilla} container>
                        <Grid
                            item
                            xl={8}
                            md={8}
                            xs={12}
                            sm={6}
                            className={classes.gridCartilla}
                        >
                            <Autocomplete
                                key={`plan-${resetPlan}`}
                                autocompleteProp='nope'
                                label="PLAN"
                                name="plan"
                                option={(planes)}
                                customClass={classes.enableTextField}
                                onChange={(event, newValue) => {
                                    setOptionsCartilla(
                                        "plan",
                                        "FiltroPlan",
                                        newValue,
                                        "string"
                                    );
                                    setSelectedValues({
                                        plan: newValue?.itemDescripcion ?? "",
                                        zone: "",
                                        city: [],
                                        provider: "",
                                        department: "",
                                        alphabeticalSearch: ""
                                    });
                                    setValues(prev => ({
                                        ...prev,
                                        zone: ""
                                    }));
                                    setModelCartilla(prev => ({
                                        ...prev,
                                        FiltroZona: "",
                                    }));
                                    setDisableZone(true);
                                    setDisableProvider(true);
                                    setDisableCity(true);
                                    setDisableAlphabeticSearch(true);
                                    setDisable(true);
                                    dispatch(cleanPerfilCompleto());
                                    setSearchAddress("")
                                }}
                                error={errors.plan}
                                loading={loading}
                                selected={
                                    planes.find(
                                        p => p.itemDescripcion === (selectedValues.plan || userPlan?.itemDescripcion)
                                    )
                                }
                            />
                        </Grid>
                        {(selectedValues.plan || userPlan?.itemDescripcion) && cartillaPlan && (
                            <Grid
                                item
                                xl={8}
                                md={8}
                                xs={12}
                                sm={6}
                                style={{ maxWidth: '300px' }}
                                container
                            >

                                <CustomButton
                                    onClick={handleDescargarCartilla}
                                    title="DESCARGAR CARTILLA"
                                    customClass={`${classes.downloadButtonCartilla} ${classes.lightLinearGradient}`}
                                />
                            </Grid>
                        )}
                    </Grid>
                    <Grid className={classes.gridContainerCartilla} container>
                        <Grid
                            item
                            xl={8}
                            md={8}
                            xs={12}
                            sm={6}
                            className={classes.gridCartilla}
                        >
                            <Autocomplete
                                autocompleteProp='nope'
                                label="ZONA"
                                name="zone"
                                option={alphabeticalOrderDescription(zonas)}
                                onChange={(event, newValue) => {
                                    setOptionsCartilla("zone", "FiltroZona", newValue, "int");
                                    setSelectedValues(prev => ({
                                        ...prev,
                                        provider: "",
                                        city: [],
                                    }));
                                    setModelCartilla(prev => ({
                                        ...prev,
                                        FiltroLocalidad: [],
                                        FiltroBarrio: [],
                                    }));
                                    setValues(prev => ({
                                        ...prev,
                                        city: []
                                    }));
                                    setSearchAddress("")
                                    dispatch(cleanPerfilCompleto());
                                }}
                                error={errors.zone}
                                loading={loading}
                                disabled={disableZone}
                                customClass={disableFunction(disableZone)}
                                selected={{ itemCodigo: modelCartilla?.FiltroZona, itemDescripcion: selectedValues?.zone }}
                            />
                        </Grid>
                        <Grid
                            item
                            xl={8}
                            md={8}
                            xs={12}
                            sm={6}
                            className={classes.gridCartillaCity}
                        >
                            <Box className={classes.descriptionTextLengthLimit} >
                                {Array.isArray(selectedValues.city) && selectedValues.city.length >= 5 && !selectedValues.city.some(c => c.itemCodigo === "TODAS") ? "Máximo a seleccionar 5 localidades" : ""}
                            </Box>
                            <AutocompleteCartillaLocalidades
                                key={`localities-${modelCartilla?.FiltroZona || selectedValues?.zone || values?.zone || 0}-${resetLocaltiesSelection}`}
                                disableCloseOnSelect
                                autocompleteProp='nope'
                                label={verifyZone()}
                                name="city"
                                disabled={disableCity}
                                customClass={disableFunction(disableCity)}
                                option={setOptionsCity(filtersCartilla)}
                                onChange={(event, newValue) => {
                                    if (newValue.some(item => item.itemCodigo === "TODAS")) {
                                        const totalOptions = newValue.find(item => item.itemCodigo === "TODAS");
                                        newValue = [totalOptions];
                                    } else {
                                        if (newValue.length > 5) {
                                            newValue = newValue.slice(0, 5);
                                        }
                                    }
                                    
                                    setOptionsCartilla(
                                        "city",
                                        "FiltroLocalidad",
                                        newValue,
                                        "array"
                                    );
                                    if (Array.isArray(selectedValues.city) && newValue.length < selectedValues.city.length) {
                                        setSelectedValues(prev => ({
                                            ...prev,
                                            provider: "",
                                            department: ""
                                        }));
                                    }
                                    dispatch(cleanPerfilCompleto());
                                }}
                                error={errors?.city}
                                loading={loading}
                                value={Array.isArray(selectedValues?.city) ? selectedValues.city : []}
                                multiple
                                sx={{
                                    '& .MuiAutocomplete-tag': {
                                        color: '#0075C9',
                                        backgroundColor: '#f2f2f2'
                                    },
                                    '& .MuiChip-deleteIcon': {
                                        color: '#0075C9 !important'
                                    }
                                }}
                            />
                        </Grid>
                        <Grid
                            item
                            xl={8}
                            md={8}
                            xs={12}
                            sm={6}
                            className={classes.gridCartilla}
                        >
                            <Autocomplete
                                autocompleteProp='nope'
                                label="TIPO DE PRESTADOR"
                                name="provider"
                                option={alphabeticalOrderDescription(tipoPrestador)}
                                onChange={(event, newValue) => {
                                    setOptionsCartilla(
                                        "provider",
                                        "FiltroTipoPrestador",
                                        newValue,
                                        "string"
                                    );
                                    setSelectedValues(prev => ({
                                        ...prev,
                                        provider: newValue?.itemDescripcion ?? "",
                                        department: ""
                                    }));
                                    setSearchAddress("");
                                    dispatch(cleanPerfilCompleto());
                                }}
                                error={errors.provider}
                                disabled={disableProvider}
                                customClass={disableFunction(disableProvider)}
                                selected={{ itemCodigo: modelCartilla?.FiltroTipoPrestador, itemDescripcion: selectedValues?.provider?.trim() }}
                            />
                        </Grid>
                        <Grid
                            item
                            xl={8}
                            md={8}
                            xs={12}
                            sm={6}
                            className={classes.gridCartilla}
                        >
                            <Autocomplete
                                autocompleteProp='nope'
                                label={verifyLabelEspecialidad(values.provider)}
                                name="department"
                                disabled={disable || !isProviderValid(selectedValues?.provider, tipoPrestador)}
                                customClass={disableFunction(disable)}
                                option={setOptionsEspecialidadesEstudios(filtersCartilla)}
                                onChange={(event, newValue) => {
                                    if (values.provider === "140") {
                                        setOptionsCartilla(
                                            "department",
                                            "FiltroEstudioComplementario",
                                            newValue,
                                            "int"
                                        );
                                    } else {
                                        setOptionsCartilla(
                                            "department",
                                            "FiltroEspecialidad",
                                            newValue,
                                            "string"
                                        );
                                    }
                                    setSearchAddress("")
                                    dispatch(cleanPerfilCompleto());
                                }}
                                error={errors.department}
                                loading={loading}
                                selected={{ itemCodigo: modelCartilla?.FiltroEspecialidad, itemDescripcion: selectedValues?.department?.trim() }}
                            />
                        </Grid>
                        <Grid
                            item
                            xl={8}
                            md={8}
                            xs={12}
                            sm={6}
                            className={classes.gridCartilla}
                        >
                            <TextField
                                id="alphabeticalSearch"
                                style={{ width: "100%", color: "blue" }}
                                label="BUSCAR POR NOMBRE DE PRESTADOR"
                                placeholder="BUSCAR POR NOMBRE DE PRESTADOR"
                                name="alphabeticalSearch"
                                className={`${classes.buttonsHeadersFilters} ${classes.searchProviderText} ${disableFunction(disableAlphabeticSearch)}`}
                                onChange={(event) => {
                                    setValues({
                                        ...values,
                                        alphabeticalSearch: event.target.value,
                                    });
                                    setSelectedValues({
                                        ...selectedValues,
                                        alphabeticalSearch: event.target.value,
                                    });
                                    setModelCartilla({
                                        ...modelCartilla,
                                        FiltroRazonSocial: event.target.value,
                                    });
                                    setSearchAddress("")
                                }}
                                value={values.alphabeticalSearch}
                                disabled={disableAlphabeticSearch}
                            />
                        </Grid>
                    </Grid>
                    <Grid
                        xl={12}
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            padding: "20px 0px",
                            flex: "0 0 100%",
                            flexWrap: 'wrap'
                        }}
                    >
                        <CustomButton
                            typeButton="header"
                            type="submit"
                            title="BUSCAR"
                            disabled={isSearchDisabled()}
                            customClass={`${classes.searchButtonCard} ${classes.lightLinearGradient} `}
                            style={{ margin: '8px' }}
                        />
                        <CustomButton
                            typeButton="header"
                            onClick={handleCleanSearch}
                            title="NUEVA BÚSQUEDA"
                            customClass={`${classes.searchButtonCard} ${classes.btnFilterAppointment}`}
                            style={{ margin: '8px' }}
                        />
                    </Grid>
                </>
            </form>
            {showErrorMessageModalRetry(errorMessage, openError, setOpenError, classes.borderWhite, classes.quickAccessIcon, classes.contentDialogTitle, "/MedicalRecords", resetMedicalRecordError)}
        </Fragment>
    );
};

export default React.memo(MedicalForm);
